<template>
  <div class="search-suggestion">
    <b-img class="search-suggestion__img" :src="icon"></b-img>
    <b-input
      v-model="query"
      ref="search"
      :placeholder="placeholder"
      type="text"
      class="search-suggestion__input form-control--plain"
      autocomplete="off"
      autofocus
      @blur="hide"
      @focus="show"
    >
    </b-input>

    <b-dropdown
      ref="dropdown"
      variant="primary"
      :class="[
        'dropdown--primary search-suggestion__dropdown',
        {
          show: showSuggestions
        }
      ]"
      :menu-class="{
        show: showSuggestions
      }"
      no-caret
    >
      <b-dropdown-item
        v-for="(suggestion, index) in suggestions"
        :key="index"
        @click="selectSuggestion(suggestion)"
        >{{ suggestion }}</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Search suggestion
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  props: ['value', 'icon', 'placeholder'],
  data: function() {
    return {
      query: null,
      suggestions: [],

      hasFocus: false
    }
  },
  computed: {
    showSuggestions() {
      return this.hasFocus && this.suggestions && this.suggestions.length > 0
    }
  },
  watch: {
    query(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue)

        this.search(newValue)
      }
    },

    value(newValue) {
      if (newValue !== this.query) {
        this.query = newValue
      }
    }
  },
  methods: {
    ...mapActions({
      getSuggestions: 'job/getJobSuggestions'
    }),

    search: debounce(async function(query) {
      this.suggestions = []

      if (!query || query.length < 3) return

      await this.getSuggestions({
        search: query
      })
        .then(data => {
          this.suggestions = data.items
        })
        /* eslint handle-callback-err: "warn" */
        .catch(error => {
          this.suggestions = []
        })
    }, 500),

    selectSuggestion(value) {
      this.query = value
      this.$emit('input', value)

      this.suggestions = []
      this.focus()
    },

    focus() {
      this.$refs.search.focus()
    },

    show() {
      this.hasFocus = true
    },

    hide() {
      setTimeout(() => {
        this.hasFocus = false
      }, 200)
    }
  }
}
</script>
<style scoped lang="scss">
.search-suggestion /deep/ {
  position: relative;

  $icon-width: 22.5px;
  $icon-indent: 25px;
  .search-suggestion__img {
    position: absolute;
    top: 18px;
    left: $icon-indent;
    width: $icon-width;
  }

  .search-suggestion__input {
    width: 100%;
    height: 100%;
    text-indent: ($icon-indent + $icon-width) + 5px;
  }

  .dropdown {
    width: 100%;

    .dropdown-toggle {
      display: none;
    }

    .dropdown-menu {
      width: 100%;
      padding: 1rem 0;
      box-shadow: var(--box-shadow);
    }
  }

  .dropdown.hide {
    display: none;
  }
}
</style>
